import { render, staticRenderFns } from "./ColonPreviewBowelCleanseForms.vue?vue&type=template&id=ee6d95b0&scoped=true&"
import script from "./ColonPreviewBowelCleanseForms.vue?vue&type=script&lang=js&"
export * from "./ColonPreviewBowelCleanseForms.vue?vue&type=script&lang=js&"
import style0 from "./ColonPreviewBowelCleanseForms.vue?vue&type=style&index=0&id=ee6d95b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6d95b0",
  null
  
)

export default component.exports